const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function streamChat({ sessionId, message, mode, article, onDelta, onDone, onError, signal }) {
  try {
    const res = await fetch(`${API}/chat/stream`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sessionId,
        message,
        mode,
        article: article || null,
      }),
      signal,
    });
    if (!res.ok || !res.body) {
      throw new Error(`Chat request failed: ${res.status}`);
    }

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop() || "";
      for (const chunk of parts) {
        const line = chunk.split("\n").find((l) => l.startsWith("data: "));
        if (!line) continue;
        const payload = line.slice(6);
        if (payload === "[DONE]") {
          onDone && onDone();
          return;
        }
        try {
          const parsed = JSON.parse(payload);
          if (parsed.delta) onDelta && onDelta(parsed.delta);
          if (parsed.error) onError && onError(parsed.error);
        } catch {
          /* ignore malformed chunk */
        }
      }
    }
    onDone && onDone();
  } catch (e) {
    if (e.name === "AbortError") return;
    onError && onError(e.message || String(e));
  }
}

export async function fetchHistory(sessionId) {
  try {
    const res = await fetch(`${API}/chat/history/${encodeURIComponent(sessionId)}`);
    if (!res.ok) return [];
    return await res.json();
  } catch {
    return [];
  }
}

export function getOrCreateSessionId(key) {
  const storageKey = `revgrow.chat.session.${key}`;
  try {
    let sid = localStorage.getItem(storageKey);
    if (!sid) {
      sid = `${key}-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
      localStorage.setItem(storageKey, sid);
    }
    return sid;
  } catch {
    return `${key}-${Math.random().toString(36).slice(2)}`;
  }
}
